import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
//import { InputMask } from '@react-input/mask';
//import { InputMask } from 'primereact/inputmask';

const LoginSemCadastro = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [empresa, setEmpresa] = useState('');

    const [telefone, setCelular] = useState('');

    const navigate = useNavigate();
    const handleSubmit = async (event) => {
      event.preventDefault(); // Evita o comportamento padrão do formulário
      try {
        const response = await fetch('http://www.criar.com.br:3000/cadastro/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email,password, empresa }), // Dados enviados ao backend
        });
        if (response.status === 200) {
          const data = await response.text();
          alert(data);
          navigate('/area');
      }
      } catch (error) {
        alert('Erro na autenticação:', error);
      }
    };
  

return(
<div>
<h1>Área Restrita</h1>

<div class='row'>
			<div class='col-4'>
				<div class='card1'>
					
				</div>
			</div>
			<div class='col-4'>
				<div class='card1'>

                <h2>Não tenho Cadastro </h2>
<form onSubmit={handleSubmit}>
<div class="form-group">
<label for="email" class="form-control">Email:</label><br/>
<input type="email" id="email" placeholder="Entre com o email" value={email} onChange={(e) => setEmail(e.target.value)} required 
  size="45"  class="form-controli"   name="email" /><br/><br/>

<label for="telefone" class="form-control">Número do Celular:</label><br/>
<input type="tel" id="telefpone" placeholder="Entre com o número do celular" value={telefone} onChange={(e) => setCelular(e.target.value)}  required 
  size="25"  class="form-controli"   name="telfone"   pattern="[0-9]{2}[0-9]{5}-[0-9]{5}" /><br/><br/>

<label for="empresa" class="form-control">Nome da Empresa:</label><br/>
<input type="text" id="empresa" placeholder="Entre com o nome da Empresa" value={empresa} onChange={(e) => setEmpresa(e.target.value)}  required 
  size="65"  class="form-controli"   name="empresa" /><br/><br/>

<label for="password" class="form-control">Senha:</label><br/>
<input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required
 size="15"  class="form-controli" /><br/>
<br/>
<button type="submit" class="botaoazul">Entrar</button><br/><br/>

</div>
</form>



                 </div>
            </div>
</div>



</div>

);
}

export default LoginSemCadastro;

